import React from "react";
import { RouteComponentProps } from "react-router-dom";
import { usePageTypeContent } from "../../hooks/UseContentHook";
import { ElectrictySupplyConfirmationPage, ElectrictySupplyConfirmationPageProps } from "./ElectrictySupplyConfirmationPage";

export const EMPTY_PAGE_CONTENT: ElectrictySupplyConfirmationPageProps = {
  pageTitle: "",
};

export const CANONICAL_LINK = "/personal/electricity/confirmation-of-supply";

export const ElectrictySupplyConfirmationPageContainer: React.FC<RouteComponentProps> = routeProps => {
  const { content } = usePageTypeContent<ElectrictySupplyConfirmationPageProps>("electricity_supply_confirmation", EMPTY_PAGE_CONTENT);
  if (content.seo) {
    content.seo.canonicalLink = CANONICAL_LINK;
  }
  return <ElectrictySupplyConfirmationPage {...routeProps} {...content} />;
};
